import type { AnalyticsUntrackedJoinSource } from "../../../api.ts";

export const UNTRACKED_JOIN_SOURCE_LABELS: Record<AnalyticsUntrackedJoinSource, string> = {
  no_invite_link: "无 invite_link",
  fallback_link: "兜底链",
  unmatched_link: "外发/未知链",
  direct_join: "直加(无邀请链)",
};

export const UNTRACKED_JOIN_SOURCE_COLORS: Record<AnalyticsUntrackedJoinSource, string> = {
  no_invite_link: "gray",
  fallback_link: "orange",
  unmatched_link: "red",
  direct_join: "violet",
};

export type UntrackedJoinsNavFilters = {
  readonly chatId?: string;
  readonly joinSource?: AnalyticsUntrackedJoinSource;
  readonly inviteLinkKey?: string;
};

export const untrackedJoinSourceLabel = (source: string): string =>
  UNTRACKED_JOIN_SOURCE_LABELS[source as AnalyticsUntrackedJoinSource] ?? source;
